import { ActionDispatch, createContext, ReducerState, useContext } from 'react'

import { Event, reducer, State } from 'domains/ProcessInvitation'

type FiniteStateTrace = State[]
type AddFiniteState = (state: State) => void
export type InvitationContextValue = [
  ReducerState<typeof reducer>,
  ActionDispatch<[action: Event]>,
  FiniteStateTrace,
  AddFiniteState,
]

export const InvitationContext = createContext<InvitationContextValue>(['START', () => null, [], () => null])

export const useInvitationContext = () => useContext(InvitationContext)
